<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :lg="6" :md="6" :span="6">
            <el-date-picker v-model="createTime" style="width: 97%" align="center" type="daterange" size="medium"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-col>
          <el-col :span="6">
            <el-input size="medium" placeholder="输入会员姓名、手机号搜索" v-model="key" style="width: 97%;"></el-input>
          </el-col>
          <el-col :span="6">
            <el-button size="medium" type="primary" icon="el-icon-search" @click="getUserInfo">搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <el-table :data="tableData" border style="width: 100%;margin-top:30px;">
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope"><span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }} </span></template>
        </el-table-column>
        <el-table-column prop="regionalSubBranch" label="区域" align="center"></el-table-column>
        <el-table-column prop="companyName" label="网点" align="center"></el-table-column>
        <el-table-column prop="realName" label="真实姓名" align="center"></el-table-column>
        <el-table-column prop="empNum" label="新一代编号" align="center"></el-table-column>
        <el-table-column prop="salaryNo" label="工资编号" align="center"></el-table-column>
        <el-table-column prop="branchNo" label="网点编号" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <span>{{ confirmScope(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 0 && checkButtonPermission('user:manage:audit:operate')"
              @click="auditStatus(scope.row)" type="primary" size="mini">审核</el-button>
            <el-button size="mini" @click="showInfo(scope.row)"
              v-if="checkButtonPermission('user:manage:audit:detail')">详情</el-button>
          </template>
          <!-- <el-button type="success" size="small" >推送</el-button> -->
        </el-table-column>
      </el-table>
      <div style="margin: 18px 0px; float: right;">
        <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
          :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "userInfo",
  data() {
    return {
      createTime: [],
      key: "",
      currentPage: 1,
      pageSize: 10,
      totalPage: 100,
      total: 156,
      tableData: []
    };
  },
  methods: {
    confirmScope(status) {
      return status === 0 ? "待审核" : status === 1 ? "审核通过" : "审核不通过";
    },
    auditStatus(row) {
      this.$alert(``, "", {
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        showClose: false,
        center: true,
        closeOnClickModal: true,
        distinguishCancelAndClose: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            setTimeout(() => {
              done();
              this.operateStatus(row.logId, 1);
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }, 1000);
          } else if (action === "close") {
            done();
          } else if (action === "cancel") {
            instance.cancelButtonLoading = true;
            instance.cancelButtonText = "执行中...";
            setTimeout(() => {
              done();
              this.$message({
                type: "info",
                message: "已驳回审核"
              });
              this.operateStatus(row.logId, 2);
              setTimeout(() => {
                instance.cancelButtonLoading = false;
              }, 300);
            }, 1000);
          }
        },
        customClass: "message-logout",
        cancelButtonText: "驳回",
        confirmButtonText: "通过",
        cancelButtonClass: "cancel-button-class",
        confirmButtonClass: "confirm-button-class",
        message: this.modelHTLM(row, 30)
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "审核已通过!"
          });
        })
        .catch(() => { });
    },
    operateStatus(logId, status) {
      this.$http.post(
        "/api/user-service/user/userInfoLog/audit?logId=" +
        logId +
        "&status=" +
        status,
        {},
        {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          // console.log(data);
          this.getUserInfo();
        })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    currentPageChange(val) {
      console.log("------currentPageChange--------" + val)
      this.currentPage = val;
      this.getUserInfo();
    },
    pageSizeChange(val) {
      console.log("------pageSizeChange--------" + val)
      this.pageSize = val;
      this.getUserInfo();
    },

    formatDate(time, fmt) {
      let o = {
        "M+": time.getMonth() + 1, //月份
        "d+": time.getDate(), //日
        "h+": time.getHours(), //小时
        "m+": time.getMinutes(), //分
        "s+": time.getSeconds(), //秒
        "q+": Math.floor((time.getMonth() + 3) / 3), //季度
        S: time.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (time.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    showInfo(row) {
      this.$alert(``, ``, {
        closeOnClickModal: true,
        showClose: false,
        showConfirmButton: false,
        dangerouslyUseHTMLString: true,
        center: true,
        customClass: "message-logout",
        message: this.modelHTLM(row, 80)
      }).catch(() => { });
    },
    modelHTLM(row, heightNum) {
      return `<h2  style="margin-top:30px;">个人信息修改</h2><div style="height:30px;"></div>
        <table border="1" style="border:1px solid #ccc;border-collapse:collapse;
        text-align:center;margin:auto;">
        <tr >
            <td style="padding:10px 20px;"></td>
            <td style="padding:10px 60px;">修改前</td>
            <td style="padding:10px 60px;">修改后</td>
        </tr>
        <tr>
            <td style="padding:10px 20px;">区域</td>
            <td style="background:#ffff99;padding:10px 60px;">${row.oldRegionalSubBranch == null ? "" : row.oldRegionalSubBranch
        }</td>
            <td style="background:#ffff99;padding:10px 60px;">${row.regionalSubBranch}</td>

        </tr>
        <tr>
            <td style="padding:10px 20px;">网点</td>
            <td style="background:#ffff99;padding:10px 60px;">${row.oldCompanyName == null ? "" : row.oldCompanyName
        }</td>
            <td style="background:#ffff99;padding:10px 60px;">${row.companyName
        }</td>
        </tr>
        <tr>
              <td style="padding:10px 20px;">真实姓名</td>
            <td style="padding:10px 60px;">${row.oldRealName == null ? "" : row.oldRealName
        }</td>
            <td style="padding:10px 60px;">${row.realName}</td>
        </tr>
        <tr>
               <td style="padding:10px 20px;">新一代编号</td>
            <td style="padding:10px 60px;">${row.oldEmpNum == null ? "" : row.oldEmpNum
        }</td>
            <td style="padding:10px 60px;">${row.empNum}</td>
        </tr>
        <tr>
               <td style="padding:10px 20px;">工资编号</td>
            <td style="padding:10px 60px;">${row.oldSalaryNo == null ? "" : row.oldSalaryNo
        }</td>
            <td style="padding:10px 60px;">${row.salaryNo}</td>
        </tr>
        <tr>
               <td style="padding:10px 20px;">网点编号</td>

            <td style="padding:10px 60px;">${row.oldBranchNo == null ? "" : row.oldBranchNo
        }</td>
            <td style="padding:10px 60px;">${row.branchNo
        }</td>
        </tr>
    </table>
    <div style="height:10px;"></div>`;
    },
    getUserInfo() {
      var reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize
      };
      if (this.createTime.length) {
        (reqParam.startTime = this.formatDate(
          this.createTime[0],
          "yyyy-MM-dd hh:mm:ss"
        )),
          (reqParam.endTime = this.formatDate(
            this.createTime[1],
            "yyyy-MM-dd hh:mm:ss"
          ));
        // setTimeout(() => {
        //   this.createTime=[]
        // }, 1000);
      }
      if (this.key) reqParam.key = this.key;
      this.$http.post("/api/user-service/user/userInfoLog/list", reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      })
        .then(resp => {
          let data = resp.data;
          // console.log(data);
          if ("success" == data.code) {
            let pageInfo = data.pageInfo;
            this.tableData = pageInfo.list;
            // this.pageSize = pageInfo.pageSize;
            this.total = pageInfo.total;
            this.totalPage = pageInfo.pages;
          } else {
            this.$alert("" + data.message, "温馨提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  },

  created() {
    this.getUserInfo();
  }
};
</script>

<style scoped>
td {
  padding: 20px 20px;
}
</style>
<style>
.message-logout {
  width: 650px !important;
}

.cancel-button-class {
  background: #e4e4e4;
  width: 160px;
  height: 46px;
  margin-right: 150px;
}

.confirm-button-class {
  color: #fff;
  background: #169bd5;
  width: 160px;
  height: 46px;
}

.el-message-box__header {
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/user/userInfo/userInfo.vue